var _defs, _rect, _rect2, _path, _path2, _g, _g2, _g3, _text, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSininLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 260,
    viewBox: "0 0 720 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bgGlow",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193 49) rotate(32.2) scale(557 270)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31FFE8",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0A6F69",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030609",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glassPanel",
    x1: 96,
    y1: 42,
    x2: 640,
    y2: 222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#8FFFF4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "turq3d",
    x1: 169,
    y1: 66,
    x2: 548,
    y2: 188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#75FFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#20EAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#04B99F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007C72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edge",
    x1: 83,
    y1: 40,
    x2: 646,
    y2: 219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFFFF8",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#23F5DF",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087C77",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shine",
    x1: 192,
    y1: 76,
    x2: 531,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FFFFFF",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "deepShadow",
    x: "-18%",
    y: "-30%",
    width: "136%",
    height: "170%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 26,
    stdDeviation: 18,
    floodColor: "#000000",
    floodOpacity: 0.48
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 18,
    floodColor: "#20EAD8",
    floodOpacity: 0.18
  })), /*#__PURE__*/React.createElement("filter", {
    id: "letterGlow",
    x: "-10%",
    y: "-25%",
    width: "120%",
    height: "150%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 2,
    floodColor: "#004E4A",
    floodOpacity: 0.95
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 13,
    floodColor: "#23F5DF",
    floodOpacity: 0.62
  })), /*#__PURE__*/React.createElement("filter", {
    id: "qrGlow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 9,
    floodColor: "#23F5DF",
    floodOpacity: 0.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 260,
    rx: 58,
    fill: "#04080B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 260,
    rx: 58,
    fill: "url(#bgGlow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 214C144 173 226 178 312 201C407 227 525 221 664 143",
    stroke: "#23F5DF",
    strokeOpacity: 0.14,
    strokeWidth: 42,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72C165 105 253 96 358 66C454 39 542 45 665 94",
    stroke: "#FFFFFF",
    strokeOpacity: 0.07,
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#deepShadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 70C83 53.4315 96.4315 40 113 40H607C623.569 40 637 53.4315 637 70V190C637 206.569 623.569 220 607 220H113C96.4315 220 83 206.569 83 190V70Z",
    fill: "url(#glassPanel)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 70C83 53.4315 96.4315 40 113 40H607C623.569 40 637 53.4315 637 70V190C637 206.569 623.569 220 607 220H113C96.4315 220 83 206.569 83 190V70Z",
    stroke: "url(#edge)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 82C103 68.7452 113.745 58 127 58H593C606.255 58 617 68.7452 617 82V102H103V82Z",
    fill: "url(#shine)",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 130,
    r: 22,
    fill: "#04080B",
    stroke: "#23F5DF",
    strokeOpacity: 0.34,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 637,
    cy: 130,
    r: 22,
    fill: "#04080B",
    stroke: "#23F5DF",
    strokeOpacity: 0.34,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 83H598V177H122V83Z",
    stroke: "#A9FFF8",
    strokeOpacity: 0.34,
    strokeWidth: 2,
    strokeDasharray: "16 13",
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#qrGlow)",
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 69,
    width: 50,
    height: 50,
    rx: 13,
    fill: "rgba(255,255,255,.16)",
    stroke: "#8FFFF4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 82,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#69FFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 82,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#69FFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 97,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#69FFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 103,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#DFFFFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541,
    y: 141,
    width: 50,
    height: 50,
    rx: 13,
    fill: "rgba(255,255,255,.16)",
    stroke: "#8FFFF4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 154,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#69FFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569,
    y: 154,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#69FFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 169,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#69FFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574,
    y: 175,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#DFFFFB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#letterGlow)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 363,
    y: 154,
    textAnchor: "middle",
    fontFamily: "Bebas Neue, Impact, Arial Black, sans-serif",
    fontSize: 96,
    letterSpacing: 14,
    fill: "#004C47",
    opacity: 0.72
  }, "SININ"), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 148,
    textAnchor: "middle",
    fontFamily: "Bebas Neue, Impact, Arial Black, sans-serif",
    fontSize: 96,
    letterSpacing: 14,
    fill: "url(#turq3d)"
  }, "SININ"), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 110,
    textAnchor: "middle",
    fontFamily: "Bebas Neue, Impact, Arial Black, sans-serif",
    fontSize: 36,
    letterSpacing: 12,
    fill: "#FFFFFF",
    opacity: 0.22
  }, "SININ"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 181,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: 8,
    fill: "#CFFFF9"
  }, "TICKETS QR")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264 194H456",
    stroke: "#23F5DF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeOpacity: 0.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSininLogo);
export default __webpack_public_path__ + "static/media/sinin-logo.12d84509c4a3fcc26b5ff13fb19f3d8b.svg";
export { ForwardRef as ReactComponent };